import * as React from 'react';

import classNames from 'classnames';

import {SaveButton} from '../button/save-button/save-button';
import {ButtonGroup} from '../button-group/button-group';
import {Link} from '../link/link';
import {PageHeader} from '../page-header/page-header';

import styles from './full-page-editor.module.css';

type Props = {
    title: string;
    onBack: () => void;
    backButtonText: string;
    previewPath?: string;
    previewButtonText?: string;
    onSaveClick: () => void;
    saveButtonText: string;
    isSaveDisabled?: boolean;
    savingText?: string;
    successText?: string;
    errorSaving?: boolean;
    isSaving: boolean;
    content: React.ReactNode;
    hasHeaderBorder?: boolean;
};

export function FullPageEditor(props: Props) {
    const contentClasses = classNames(styles['content-container'], {
        [styles['content-container--header-border']]: props.hasHeaderBorder,
    });

    return (
        <>
            <PageHeader
                backButton={{
                    onClick: props.onBack,
                    text: props.backButtonText,
                }}
                title={props.title}
                actionButtons={
                    <ButtonGroup>
                        {props.previewPath && props.previewButtonText ? (
                            <Link
                                variant='button-secondary'
                                size='big'
                                href={props.previewPath}
                                newTab={true}
                            >
                                {props.previewButtonText}
                            </Link>
                        ) : undefined}
                        <SaveButton
                            isSaving={props.isSaving}
                            // @ts-expect-error
                            onClick={props.onSaveClick}
                            size='big'
                            buttonText={props.saveButtonText}
                            savingText={props.savingText || 'Saving…'}
                            successText={props.successText || 'Success!'}
                            errorSaving={props.errorSaving}
                            disabled={props.isSaveDisabled}
                        />
                    </ButtonGroup>
                }
            />
            <div className={contentClasses}>{props.content}</div>
        </>
    );
}
